import { render } from "./ChatConversation.vue?vue&type=template&id=3ffd9a99"
import script from "./ChatConversation.vue?vue&type=script&lang=js"
export * from "./ChatConversation.vue?vue&type=script&lang=js"

import "./ChatConversation.vue?vue&type=style&index=0&id=3ffd9a99&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__